import module from 'recursoshumanos/module.js'
import template from './template.html'

export class PagosSUAMensajeComponent {
  mensaje
  onClose

  cerrar () {
    this.onClose(null)
  }

  aceptar () {
      this.onClose({$event: {data: this.mensaje || ''}})
  }
}

module.component('recursoshumanosPagosSuaMensaje', {
  controller: PagosSUAMensajeComponent,
  template,
  bindings: {
    mensaje: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/pagossua/mensaje/component.js